import { render, staticRenderFns } from "./FrameComment.vue?vue&type=template&id=6ca043e8&scoped=true"
import script from "./FrameComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrameComment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FrameComment.vue?vue&type=style&index=0&id=6ca043e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca043e8",
  null
  
)

export default component.exports